// extracted by mini-css-extract-plugin
export default {"lottieAccessory":"ScopedModeChip_lottieAccessory__VegqH","isChipsMotionV1":"ScopedModeChip_isChipsMotionV1__H+1p4","mobile":"ScopedModeChip_mobile__ppUaP"};